module.exports = __webpack_public_path__ + "static/media/samsung.2703b1b2.jpg";